import styled from 'styled-components'
import { Switch } from 'antd'

export const MySwitch = styled(Switch)<{ dark?: boolean }>`
  background: ${props =>
    props.dark ? props.theme['neutral-300'] : props.theme['neutral-300']};
  .ant-switch-handle {
    &::before {
      background: ${props =>
        props.dark ? props.theme['neutral-400'] : props.theme['neutral-400']};
    }
  }
  &:focus {
    box-shadow: none;
  }
  &.ant-switch-small {
    height: 16px;
    min-width: 32px;
    .ant-switch-handle {
      width: 12px;
      height: 12px;
    }
  }
  &.ant-switch-checked {
    background: ${props =>
      props.dark ? props.theme.primary : props.theme.primary};
    .ant-switch-handle {
      &::before {
        background: #fff;
      }
    }
    &.ant-switch-small {
      .ant-switch-handle {
        left: calc(100% - 12px - 2px);
      }
    }
    &:focus {
      box-shadow: none;
    }
  }
`
